import {Component, OnInit} from '@angular/core';
import '../../../../assets/js/components/hs.svg-injector.js';
import {TripEntry} from "../../widgets-module/components/trip-list/trip-list.component"; // for the top cutout photo

@Component({
  selector: 'app-guides-page',
  templateUrl: './guides-page.component.html',
  styleUrls: ['./guides-page.component.css']
})
export class GuidesPageComponent implements OnInit {
  tripListTitle = 'Ready for your Kilimanjaro Adventure?';
  tripListSubtitle = 'Explore our Kilimanjaro Climb Itineraries';

  tripEntries = [
    new TripEntry({title: 'Machame Route', route: '/kilimanjaro/machame-route'}),
    new TripEntry({title: 'Lemosho Route', route: '/kilimanjaro/lemosho-route'}),
    new TripEntry({title: 'Marangu Route', route: '/kilimanjaro/marangu-route'})
  ];

  constructor() { }

  ngOnInit() {
  }

  isMobile() {
    return document.body.clientWidth <= 769;
  }
}
